import './stayUnitPrices.css';

import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

/*
 * Price for several unit types in one stay.
 * Closed: "5 units × 4 nights   ₹1,26,000"
 * Open:   each unit with its own math ("Tent × 3 · ₹5,500 × 4 nights × 3   ₹66,000")
 *
 * lines: [{ unitName, rooms, listPrice, listBase, quantityLabel }]
 * format: turns a number into a price string (with the currency symbol)
 */
export default function StayUnitPrices({ lines = [], nights, format }) {
    const [open, setOpen] = useState(false);

    const rooms = lines.reduce((total, line) => total + (Number(line.rooms) || 0), 0);
    const total = lines.reduce((sum, line) => sum + (Number(line.listBase) || 0), 0);
    const summary = [rooms > 0 && plural(rooms, 'unit', 'units'), nights > 0 && plural(nights, 'night', 'nights')]
        .filter(Boolean)
        .join(' × ');

    return (
        <div className='stayUnitPrices'>
            <button
                type='button'
                className='tripPriceCal stayUnitPricesToggle'
                aria-expanded={open}
                onClick={() => setOpen((v) => !v)}
            >
                <span className='tripBookPrice stayUnitPricesLabel'>
                    {summary || `${lines.length} units`}
                    <ChevronDown size={16} className={`stayUnitPricesChevron ${open ? 'open' : ''}`} />
                </span>
                <span className='tripBookPrice'>{format(total)}</span>
            </button>

            {open && (
                <ul className='stayUnitPricesList'>
                    {lines.map((line, index) => (
                        <li key={line.unitId || `${line.unitName}-${index}`} className='stayUnitPriceRow'>
                            <div>
                                <p className='stayUnitPriceName'>
                                    {line.unitName}
                                    {line.rooms ? ` × ${line.rooms}` : ''}
                                </p>
                                <p className='stayUnitPriceMath'>
                                    {format(line.listPrice)} × {line.quantityLabel}
                                </p>
                                {line.specialNote && <p className='stayUnitPriceMath'>{line.specialNote}</p>}
                            </div>
                            <p className='stayUnitPriceName'>{format(line.listBase)}</p>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
